import React from "react";
import { PublicClientApplication } from '@azure/msal-browser';

import AWS from 'aws-sdk';

const ACCESS_KEY_ID =  "AKIA55E32CSUMKAN7HHS";
const SECRET_ACCESS_KEY = "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";
const BUCKET_NAME = "6thstreet-data-report";
const BUCKET_KEY = "recan-service/validEmails.json";

AWS.config.update({
    accessKeyId : ACCESS_KEY_ID,
    secretAccessKey : SECRET_ACCESS_KEY
});
AWS.config.region = 'eu-west-1';

export const UserContext = React.createContext();
export const useUser = () => React.useContext(UserContext);

export const UserProvider = ({children}) => {

  const [publicClientApplication] = React.useState(
    new PublicClientApplication({
      auth: {
          clientId: process.env.REACT_APP_MS_CLIENT_ID,
          redirectUri: window.location.origin
      },
      cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: true
      }
    })
  );
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  const isInteractionRequired = (err) => {
    if (!err.message || err.message.length <= 0) {
      return false;
    }

    return (
      err.message.indexOf('consent_required') > -1 || err.message.indexOf('interaction_required') > -1 || err.message.indexOf('login_required') > -1 || err.message.indexOf('no_account_in_silent_request') > -1
    );
  };

  const getAccessToken = async () => {
    try {
      const accounts = publicClientApplication.getAllAccounts();
      if (accounts.length <= 0){
        throw new Error('login_required');
      }
      // Get the access token silently
      // If the cache contains a non-expired token, this function
      // will just return the cached token. Otherwise, it will
      // make a request to the Azure OAuth endpoint to get a token
      const silentResult = await publicClientApplication.acquireTokenSilent(
        {
          scopes: ["openid", "profile", "User.Read"],
          account: accounts[0]
        }
      );
      return {
        accessToken: silentResult.accessToken,
        name: silentResult.account.name,
        email: silentResult.account.username
      };
    }
    catch (err) {
      // If a silent request fails, it may be because the user needs
      // to login or grant consent to one or more of the requested scopes
      if (isInteractionRequired(err)){
        const interactiveResult = await publicClientApplication.acquireTokenPopup(
          {
              scopes: ["openid", "profile", "User.Read"]
          }
        );
        return {
          accessToken: interactiveResult.accessToken,
          name: interactiveResult.account.name,
          email: interactiveResult.account.username
        };
      }
      throw err;
    }
  };

  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const {accessToken, name, email} = await getAccessToken(["openid", "profile", "User.Read"]);
      const bucket = new AWS.S3();
      const s3params = {
          Bucket: BUCKET_NAME,
          Key: BUCKET_KEY,
      };
      bucket.getObject (s3params, (err, data) => {
        const ValidEmails = JSON.parse(data.Body.toString('utf-8'));
        if(ValidEmails.includes(email.toLowerCase())) {
          if (accessToken) {
            // Initialize Graph client
            // const client = Client.init();
            setUserInfo({
              name,
              email
            })
            setIsAuthenticated(true);
            setIsLoading(false);
          }
        } else{
          setIsAuthenticated(false);
          setUserInfo(null);
          setError("Permission to access. Please contact admin !");
          setIsLoading(false);
        }
      });
    }
    catch(err) {
      setIsAuthenticated(false);
      setUserInfo(null);
      setError(err);
      setIsLoading(false);
    }
  };

  const signIn = async () => {
    try{
      // Login via popup
      await publicClientApplication.loginPopup(
          {
            scopes: ["openid", "profile", "User.Read"],
            prompt: "select_account"
        });

      // After login, get the user's profile
      await getUserProfile();
    }
    catch(err) {
      setIsAuthenticated(false);
      setUserInfo(null);
      setError(err);
      setIsLoading(false);
    }
  };

  const signOut = async () => {
    const currentAccount = publicClientApplication.getAccountByUsername(userInfo.email);
    if(currentAccount){
      await publicClientApplication.logout({
        account: currentAccount,
        postLogoutRedirectUri: window.location.origin
      });
    }
  };

  React.useEffect(() => {
    // If MSAL already has an account, the user
    // is already logged in
    const accounts = publicClientApplication.getAllAccounts();

    if (accounts && accounts.length > 0) {
      // Enhance user object with data from Graph
      getUserProfile();
    }
    else{
      setIsLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        authenticationState: {
          isAuthenticated,
          isLoading,
          error
        },
        userInfo,
        signIn,
        signOut
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
